import React from "react";
import PropTypes from "prop-types";
import { MetaData } from "./common/meta";
import { Layout } from "./common";
import { OverrideGlobalStyles } from "./OverrideGlobalStyles";
import { ThemeProvider } from "../ng-components/theme";

export function PostPage({ data, ...rest }) {
    return <Page data={{ ghostPost: data }} {...rest} />;
}

export function ListingPage({ data, ...rest }) {
    const { title: heading } = data;
    return <Page data={{ ghostPage: data }} heading={heading} {...rest} />;
}

function Page({ data, location, children, heading = "", theme = {} }) {
    const {
        pageBackgroundColor = "#f0f0f0",
        pageHeadingColor = "#393872",
        pageBackgroundTop = null,
        pageBackgroundBottom = null,
    } = theme;

    const { slug } = data?.ghostPage || data?.ghostPost || {};

    return (
        <>
            <MetaData data={data} location={location} />
            <Layout bodyClass={`page ${slug} ng-page elbrus-headless`}>
                <ThemeProvider theme={theme}>
                    <OverrideGlobalStyles>
                        <div className="page__wrapper">
                            {heading && (
                                <h1 className="page__heading">{heading}</h1>
                            )}
                            <div className="page__container">{children}</div>
                        </div>
                    </OverrideGlobalStyles>
                </ThemeProvider>
            </Layout>
            <style jsx>{`
                .page__wrapper {
                    padding: 1.875em 0 6em;
                    // Account for padding of parent element so background
                    // colour applies to the entire page visually
                    margin: -1.875em 0 -2em;
                    background-color: ${pageBackgroundColor};
                }
                .page__heading {
                    font-size: 3em;
                    line-height: 1;
                    text-align: center;
                    padding: 1em 0 1em;
                    color: ${pageHeadingColor};
                }
                .page__wrapper {
                    background-image: url(${pageBackgroundTop}),
                        url(${pageBackgroundBottom});
                    background-position: top left, bottom left;
                    background-size: contain;
                    background-repeat: no-repeat;
                    padding-bottom: 21em;
                    padding-bottom: 27vw;
                }
                @media (min-width: 45em) {
                    .page__heading {
                        font-size: 4em;
                        padding: 1.75em 0 1.75em;
                        padding-bottom: 8vw;
                    }
                }
            `}</style>
            <style jsx global>{`
                .page.ng-page .ni-footer {
                    margin-top: 0;
                }
            `}</style>
        </>
    );
}

Page.propTypes = {
    data: PropTypes.object.isRequired,
    heading: PropTypes.string,
    location: PropTypes.object.isRequired,
    children: PropTypes.node.isRequired,
    theme: PropTypes.shape({
        pageBackgroundColor: PropTypes.string,
        pageHeadingColor: PropTypes.string,
    }),
};

Page.defaultProps = {
    heading: "",
    theme: {},
};
